import React, { Component } from "react";
import notification from 'c-notification';
import LoginPop from "./component/login-pop";
import Profile from "./component/profile/index";
import lang from './lang';
import IMView from './im/';
import Modal from 'boron/ScaleModal';
import Cache from 'c-cache';
import SelectCountry from './component/select-country';
import GiftList from './living/gift/giftlist';
import SensitiveWord from './component/sensitive-words/index';

const cache = new Cache({
    prefix: 'pcuplive'
});

const style = {
    modalStyle: {
        width: '700px',
        zIndex: 10001
    },
    contentStyle: {
        width: '700px',
        height: '560px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(23,19,31, 0.7)",
        zIndex: 10000
    }
}

function HocWrapper(ComposedComponent) {
    class AppWrapper extends Component {
        constructor(props) {
            super(props);

            this.state = {
                lang: UP.Global.siteLanguage,
                inited: 0,
                showLoginPop: 0,
                showIM: 0,
                uid: 0
            };

            this.bindEvent();
        }

        componentDidMount() {
            this.asyncLanguage(this.state.lang, () => {
                this.getLoginUserProfile();
            });
        }

        getLanguagePackFromLocal(file) {
            let langpack = cache.getCache('langpack') || {};

            if (langpack.data) {
                if (langpack.version == projectVersion) {
                    return langpack.data[file];
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }

        asyncLanguage(langtype, callback) {
            let arr = langtype.split('-');
            let file = arr[0] + arr[1].toLowerCase();
            let langpack = this.getLanguagePackFromLocal(file);

            if (langpack) {
                window.LangPack = langpack;

                if (typeof callback == 'function') {
                    callback();
                }
            } else {
                if (file !== 'enus') {
                    System.import(/*webpackChunkName: "async"*/'./lang/' + file).then(LangPack => {
                        window.LangPack = LangPack;

                        this.updateLangPack(file, LangPack);

                        if (typeof callback == 'function') {
                            callback();
                        }
                    }).catch(err => {
                        console.log(err);
                    });
                } else {
                    window.LangPack = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }
            }
        }

        updateLangPack(file, data) {
            let langpack = cache.getCache('langpack') || {};

            if (langpack.version == projectVersion) {
                langpack.data[file] = data;
            } else {
                cache.removeCache('langpack');
                langpack = {
                    version: projectVersion,
                    data: {}
                };
                langpack.data[file] = data;
            }

            cache.setCache('langpack', langpack);
        }

        getLoginUserProfile() {
            let uid = UP.Global.getUserId() || 0;

            this.getProfileByUserId(uid);
        }

        bindEvent() {
            $.channel.on("chooseLanguage", type => {
                UP.Global.DA.add({
                    eventName: 'ChooseLanguage',
                    action: 'click'
                });

                UP.Global.chooseLanguage(type);

                this.asyncLanguage(type, () => {
                    this.setState({
                        lang: type
                    });
                });
            });

            $.channel.on('login', () => {
                style.contentStyle.width = '400px';
                style.contentStyle.height = '409px';
                style.modalStyle.width = '400px';
                this.showLoginPop();
            });

            $.channel.on('logout', () => {
                UP.Global.DA.add({
                    eventName: 'Logout Box',
                    action: 'Logout'
                });
                UP.Global.clearUserInfo();
                // this.setState({
                //     uid: 0
                // });
                // 用户登出，重新走流程
                this.getLoginUserProfile();

                this.setState({
                    showIM: 0
                });
            });


            $.channel.on('loginSuccess', (data) => {
                UP.Global.writeUserInfo(data);
                this.loginSuccess(data);
                this.getLoginUserProfile();
                this.showGuidRoomBox();


            })

            $.channel.on('authSuccess', (data) => {
                UP.Global.cacheUserToken(data.userToken);
                this.getProfileByUserId(data.uid);
                this.showGuidRoomBox();
            })

            $.channel.on('registerVisitorSuccess', (data) => {
                UP.Global.writeUserInfo(data);
                this.loginSuccess(data);
            });
        }
        showGuidRoomBox() {
            //登录成功判断是否有新手礼物 弹新手引导框 用户进入过直播间则不弹框
            let isShow = this.isShowGuidEnterRoom();
            if (isShow) {

                $.channel.on('gotGiftListForGuid', () => {
                    $.channel.off('gotGiftListForGuid');
                    $.channel.emit('showGuidGift', GiftList.hasGuidGift);
                    $.channel.off('showGuidGift');

                });
                GiftList.getGiftLabel();
            }
        }

        isShowGuidEnterRoom() {
            let showGuid = cache.getCache('getIntoRoom');
            if (showGuid) {
                return false;
            }
            return true;
        }

        isEmptyObject(obj) {

            for (var key in obj) {
                return false
            };
            return true
        }

        componentWillUnmount() {
            $.channel.off("chooseLanguage");
            $.channel.off("login");
            $.channel.off("logout");
            $.channel.off('loginSuccess');
            $.channel.off('authSuccess');
        }

        getProfileByUserId(uid) {
            let self = this;

            let getUserProfileCount = 0; // 请求失败，则请重新求。重试三次

            let getUserProfile = (uid) => {

                let promise = new Profile(uid).promise;

                promise.done((data) => {
                    if (data.hostStatus) {
                        // 当前用户登录信息
                        UP.Global.writeUserInfo(data);
                    }
                    this.loginSuccess(data);
                }).fail(() => {

                    ++getUserProfileCount;

                    if (getUserProfileCount > 3) {

                        notification.simple(lang.template('获取用户信息失败, 请稍后再试'), 100000);
                    } else {
                        getUserProfile(uid);
                    }
                });
            }

            getUserProfile(uid);
        }

        hideLoginPop = (e) => {

            this.refs.modal.hide();
            this.setState({
                showLoginPop: 0 // 为了销毁loginpop中的一些处理。例如：qrcode查询的定时器
            }, () => {
                UP.Global.isLoginPop = false;
            });

            // if (location.href.indexOf('/recharge') > -1 ) {
            //     history.back();
            // }
        }

        showLoginPop = (e) => {

            /*在global中储存登录弹框显示隐藏状态**/
            UP.Global.isLoginPop = true;
            this.setState({
                showLoginPop: 1
            }, function() {
                this.refs.modal.show();
            });
        }

        loginSuccess(data) {
            let self = this;

            if (this.state.showLoginPop == 1) {
                this.hideLoginPop();
            }

            if (!data.countryCode) {
                this.update();
                // debugger;
                setTimeout(() => {
                    SelectCountry.create({
                        username: SensitiveWord.filter(data.username),
                        gender: data.gender,
                        onComplete: function(countryCode) {
                            data.countryCode = countryCode;
                            self.setState({
                                inited: 0
                            }, function() {
                                this.update();

                            });

                        }
                    });
                }, 500)
            } else {
                this.update();
                if (UP.Global.isRegisterRealUser()) {}
            }

            if (UP.Global.isRegisterRealUser()) {
                this.setState({
                    showIM: 1
                });
            }
        }

        update() {
            this.setState({
                inited: 1,
                uid: UP.Global.getUserId()
            });
        }

        render() {
            let $content;

            return (
                <div id="J-PageWrap">
                    { this.state.inited == 1 ? <ComposedComponent key={`${this.state.lang.replace('-','')}${this.state.uid}`}  lang = {this.state.lang} /> : null }
                    <Modal ref="modal" closeOnClick={false} modalStyle={style.modalStyle}  backdropStyle={style.backdropStyle} contentStyle={style.contentStyle}>
                        { this.state.showLoginPop == 1 ? <LoginPop onClose={this.hideLoginPop}/> : null }
                    </Modal>
                    { this.state.showIM == 1 ? <IMView ref="im"/> : null}
                </div>
            );
        }
    }

    return AppWrapper;
}

module.exports = HocWrapper;


// WEBPACK FOOTER //
// ./js/hoc.js